// Module
var code = "<div class=\"contract\"> <ng-include src=\"'/presentation/menu/sidemenu.html'\"></ng-include> <div class=\"contract-canvas container-fluid\"> <react-download watch-depth=\"one-way\"></react-download> <messages></messages> </div> </div> ";
// Exports
module.exports = code;